import { faCopy, faCheck } from '@fortawesome/pro-regular-svg-icons'
import { Box, Flex, Text, type TextProps, Tooltip } from '@mantine/core'
import { useClipboard } from '@mantine/hooks'
import { type PropsWithChildren } from 'react'

import { Icon } from '../../src'

type TextCopyProps = TextProps & {
  iconColor?: string
  children?: React.ReactNode
  withLabel?: boolean
  withIcon?: boolean
}

export function TextCopy({
  children,
  iconColor,
  withLabel = true,
  withIcon = true,
  ...props
}: PropsWithChildren<TextCopyProps>) {
  const clipboard = useClipboard({ timeout: 500 })

  return (
    <Tooltip label='Copied' opened={clipboard.copied} withArrow={false}>
      <Text truncate='end' {...props}>
        <Flex
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation()
            clipboard.copy(children)
          }}
          align='center'
          gap='xs'
          style={{ cursor: 'pointer' }}
        >
          {withLabel && (
            <Box
              style={{
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {children}
            </Box>
          )}

          {withIcon && (
            <Icon
              icon={clipboard.copied ? faCheck : faCopy}
              size='xs'
              color={iconColor && 'gray.5'}
            />
          )}
        </Flex>
      </Text>
    </Tooltip>
  )
}
